<template lang="pug">
  .medicos-container
    modal-medicos(:openModal="modal", @close="closeModal", :edicao="medicosEdicao", @atualiza="atualizaLista")
    .sem-cadastro(v-if="!this.medicos.length") Nenhum médico cadastrado!
    ul.corpo-lista(v-else)
      li.lista(@click="abreModalEditar(list)", v-for="(list, a) in medicos", :key="a", :class="[list.status === 'I' ? 'inativo' : '']")
        .icn
          img(v-if="list.status === 'A'", src="../../assets/medicos.svg")
          img(v-else, src="../../assets/medicos-inativos.svg")
        .info
          .nome-medico {{ `${list.termo_tratamento}.` }} {{ list.nome }}
          .dados-medico
            .crm {{ list.infoCrms }}
              span(v-if="list.infoCrms") ,
            .especialidade {{ list.infoEspecialidade }}
              span(v-if="list.infoEspecialidade") ,
            .rqe {{ list.infoRqe }}
        .acao
          i(class="fa fa-pencil", aria-hidden="true")

    //.paginacao
      el-pagination(layout="prev, pager, next", prev-text="Anterior", next-text="Próximo", :total="496")
</template>

<script>
import ModalMedicos from './ModalMedicos'
import Services from '../../utils/services'
import { mapGetters, mapMutations } from 'vuex'
import moment from 'moment'
moment.locale('pt-BR')

export default {
  components: { ModalMedicos },

  created() {
    this.getEspecialidades()
    this.getUnidades()
    this.getMedicos()
  },

  data: () => ({
    modal: false,
    busca: '',
    especialidades: [],
    unidades: [],
    medicos: [],
    medicosEdicao: '',
  }),

  computed: {
    ...mapGetters(['getModal'])
  },

  watch: {
    getModal(){
      if(this.getModal === 'Medicos') this.abreModalCadastrar()
    }
  },

  methods: {
    ...mapMutations(['setLoad', 'setModal']),

    /* Método que lista os medicos */
    async getMedicos(){
      this.setLoad(true)
      let medicos = await Services.get('/medico')
      this.medicos = medicos.lista.map(e => {
        let arrCrm = []
        let arrEspec = []
        let arrRqe = []
        e.crms.map(f => {
          arrCrm.push('CRM '+f.crm+' - '+f.uf_registro.toUpperCase())
        })
        e.especialidades.map(espec => {
          arrEspec.push(espec.nome)
          arrRqe.push('RQE '+espec.rqe)
        })
        e.infoCrms = arrCrm.join(', ')
        e.infoEspecialidade = arrEspec.join(' e ')
        e.infoRqe = arrRqe.join(' - ')
        e.auxUnidade = this.unidades
        e.auxEspecialidade = this.especialidades
        return e
      })
      if(this.medicos) {
        this.setLoad(false)
      }
      console.log('medicos',this.medicos)
    },

    /* Metodo que preenche o select de especialidades */
    async getEspecialidades(){
      let auxEspecialidade = await Services.get('/especialidade')
      this.especialidades = auxEspecialidade.filter(e => e.status === 'A')
    },

    /* Metodo que preenche o select de unidades */
    async getUnidades(){
      let auxUnidade = await Services.get('/unidade-medica')
      this.unidades = auxUnidade.filter(e => e.status === 'A')
    },

    /* Metodo que abre o modal de um novo cadastro */
    abreModalCadastrar(){
      this.modal = true
    },

    /* Metodo que abre o modal de edição */
    abreModalEditar(list) {
      this.modal = true
      this.medicosEdicao = list
    },

    /* Metodo que atualiza a lista de pacientes quando houver sucesso no cadastro ou edicao */
    atualizaLista(){
      this.getMedicos()
    },

    /* Metodo que fecha o modal */
    closeModal(){
      this.modal = false
      this.setModal('')
      this.medicosEdicao = ''
    }
  }
}
</script>

<style lang="scss">
.medicos-container{
  width: 1100px;
  height: calc(100% - 120px);
  margin: 0 auto;
  overflow: auto;
  
  &::-webkit-scrollbar {
    display: none;
  }

  .sem-cadastro{
    margin-top: 100px;
    width: 90%;
    margin: 100px auto;
    height: 200px;
    background: rgb(245,245,245,.3);
    border-radius: 10px;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 18px;
    font-weight: 300;
    color: red;
    box-shadow: 1px 3px 6px rgba(0,0,0,.3);
  }

  ul.corpo-lista{
    margin: 0;
    padding: 25px 0;
    box-sizing: border-box;

    li.lista{
      width: 100%;
      height: 85px;
      padding: 0 25px;
      margin-bottom: 15px;
      border: 1px solid #CBCBCB;
      border-radius: 10px;
      box-sizing: border-box;
      cursor: pointer;
      list-style: none;
      display: flex;
      align-items: center;
      justify-content: space-between;

      &.inativo{
        .info{
          .nome-medico{
            color: #666;
          }
          .dados-medico{
            color: #CBCBCB;
          }
        }
      }

      &:last-child{
        margin-bottom: 0;
      }

      .icn{
        margin-right: 25px;
      }

      .info{
        flex: 1;
        display: flex;
        height: 100%;
        flex-direction: column;
        justify-content: center;

        .nome-medico{
          font-size: 20px;
          color: #0180FF;
          font-weight: 400;
          margin-bottom: 2px;
        }
        .dados-medico{
          display: flex;
          font-size: 16px;
          color: #000;
          font-weight: 100;

          .crm, .especialidade, .rqe{
            margin-right: 5px;
          }
        }
      }

      .acao{
        i{
          font-size: 26px;
          transform: rotate(-10deg);
          color: #0180FF;
        }
      }
    }
  }

  .paginacao{
    display: flex;
    justify-content: center;
    margin-bottom: 30px;
  }
}
</style>